import * as types from '../mutationsTypes/MutationsTypes'

const state = {
  touchDevice: false,
  mousePosition: {
    x: null,
    y: null
  },
  mouseInWindow: true,
  clientDimensions: {
    width: 0,
    height: 0,
    hoverZone: 0
  },
  timer: 0,
  timerMax: 5000,
  aboutDisplay: false,
  loaded: false
}

const mutations = {
  [types.SET_TOUCH_DEVICE]: (state, value) => {
    state.touchDevice = value
  },
  [types.SET_MOUSE_POSITION]: (state, mousePosition) => {
    state.mousePosition = mousePosition
  },
  [types.SET_MOUSE_IN_WINDOW]: (state, mouseInWindow) => {
    state.mouseInWindow = mouseInWindow
  },
  [types.SET_CLIENT_DIMENSIONS]: (state, clientDimensions) => {
    state.clientDimensions = clientDimensions
  },
  [types.SET_TIMER]: (state, value) => {
    state.timer = value
  },
  [types.SET_ABOUT_DISPLAY]: (state, value) => {
    state.aboutDisplay = value
  },
  [types.SET_LOADED]: (state, value) => {
    state.loaded = value
  }
}

const getters = {
  touchDevice: state => state.touchDevice,
  mousePosition: state => state.mousePosition,
  mouseInWindow: state => state.mouseInWindow,
  clientDimensions: state => state.clientDimensions,
  timer: state => state.timer,
  timerMax: state => state.timerMax,
  aboutDisplay: state => state.aboutDisplay,
  loaded: state => state.loaded
}

const actions = {
  setTouchDevice ({commit}, value) {
    commit([types.SET_TOUCH_DEVICE], value)
  },
  setMousePosition ({commit}, mousePosition) {
    commit([types.SET_MOUSE_POSITION], mousePosition)
  },
  setMouseInWindow ({commit}, mouseInWindow) {
    commit([types.SET_MOUSE_IN_WINDOW], mouseInWindow)
  },
  setClientDimensions ({commit}, clientDimensions) {
    commit([types.SET_CLIENT_DIMENSIONS], clientDimensions)
  },
  setTimer ({commit}, value) {
    commit([types.SET_TIMER], value)
  },
  setAboutDisplay ({commit}, value) {
    commit([types.SET_ABOUT_DISPLAY], value)
  },
  setLoaded ({commit}, value) {
    commit([types.SET_LOADED], value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/App.js